import { COMPONENT, register } from '!/repository'
import { LanguagePicker } from './ui'

export * as languagePickerModel from './model'
register(LanguagePicker, 'LanguagePicker', COMPONENT)
